export default __webpack_public_path__ + "static/media/icon-folder.34a7e1e5.svg";